addEventListener('turbo:click', (e) => {
  if (e.target.getAttribute('data-smooth-scroll') === null) {
    window.disableSmoothScroll();
  }
  document.getElementById('navbarNav').classList.remove('show');
});

addEventListener('turbo:load', () => {
  window.enableSmoothScroll();
  if (document.getElementById('image-header')) {
    document
      .getElementById('image-header')
      .classList.add('image-header--loaded');
  }
  document.getElementById('navbarNav').classList.remove('show');
});
